const { BUSINESS_MODELS } = require("../../constants");

const getIsB2BSelected = businessModel => businessModel === BUSINESS_MODELS.B2B;

module.exports = { getIsB2BSelected };
